// 公用gettres
const getters = {}
export default getters
